// extracted by mini-css-extract-plugin
module.exports = {"job":"styles_job__SLPz6","fade-out":"styles_fade-out__zRvFx","fade-in":"styles_fade-in__AXO3_"};